import moment from 'moment'

export const secondsToMills = (date: number): number => date * 1000.0

export const unixTimestampToDate = (date: number | string): Date => new Date(Number(date) * 1000)

export const timeToDateFormatter = (date: Date): string => moment(date).format('DD/MM/YY')

/**
 * =====================================================
 * sorting functions
 * =====================================================
 */

export const byDate = <T extends { date: number }>(a: T, b: T) => {
  if (a.date < b.date) return -1
  if (a.date > b.date) return 1
  return 0
}

export const byTimestamp = <T extends { timestamp: number }>(a: T, b: T) => {
  if (a.timestamp < b.timestamp) return -1
  if (a.timestamp > b.timestamp) return 1
  return 0
}
